// ⛔️Generated file. Manual changes will be lost ⛔️

export class ScriptPreferences {
    public static readonly Traditional: string = 'traditional';
    public static readonly Simplified: string = 'simplified';
}
